(function($) {
	$(document).ready( function() {
		$(".ppclp-logos-carousel").owlCarousel({
			items: 6,
			autoWidth: true,
			margin: 45,
			navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-angle-right"></i>'],
			dots: false,
			responsive : {
				0: {
					items:3,
					nav: true,
					autoWidth: false,
				},
				992: {
					items: 6,
					nav: false,
					autoWidth: true
				}
			}
		});

		$(".ppclp-team-carousel").owlCarousel({
			nav: true,
			margin: 20,
			items: 2,
			navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-angle-right"></i>'],
			responsive : {
				0: {
					items: 1
				},
				992: {
					items: 2
				}
			}
		});

		$(".ppclp-testimonials-carousel").owlCarousel({
			margin: -420,
			nav: true,
			items: 3,
			center: true,
			loop:true,
			mouseDrag: false,
			touchDrag: false,
			navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-angle-right"></i>'],
			responsive : {
				0: {
					items: 1,
					margin: 0,
					mouseDrag: true,
					touchDrag: true,
					autoplay: true,
					nav: false
				},
				992: {
					margin: -420,
					mouseDrag: false,
					touchDrag: false,
				}
			}
		});

		$('.ppclp-accordion').on('click', '.ppclp-accordion-header', function() {
			var acc_this	= $(this);
			var accordion 	= acc_this.closest('.ppclp-accordion');

			if( acc_this.hasClass('ppclp-active') ) {
				acc_this.next('.ppclp-accordion-content').slideUp();
				acc_this.removeClass('ppclp-active');
			} else {
				accordion.find('.ppclp-accordion-header').removeClass('ppclp-active');
				accordion.find('.ppclp-accordion-content').slideUp();
				acc_this.next('.ppclp-accordion-content').slideDown();
				acc_this.addClass('ppclp-active');
			}
		});

		$("#button").click(function() {
			$('html, body').animate({
				scrollTop: $("#myDiv").offset().top
			}, 2000);
		});

		$(".ppclp-btn").on("click", function(event) {
			if (this.hash !== "") {
				event.preventDefault();

				var btn_hash = this.hash;

				$("html, body").animate({
					scrollTop: $(btn_hash).offset().top - 150
				}, 800, function() {
					// Add hash (#) to URL when done scrolling (optional)
					window.location.hash = btn_hash;
				});
			}
		});

		var scroll_top_btn = $('#ppclp-scroll-to-top');

		$(window).on('scroll', function() {
			if ($(this).scrollTop() > 400) {
				scroll_top_btn.fadeIn();
			} else {
			  scroll_top_btn.fadeOut();
			}
		});

		scroll_top_btn.on('click', function() {
			$('html, body').animate({
				scrollTop: 0
			}, 400);
		});
	});
})(jQuery);